import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AppFilter } from '@app/shared/models';

@Injectable({
  providedIn: 'root',
})
export class RateLimitService {
  apiUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getRateLimitProfiles(payload) {
    return this._http.get(`${this.apiUrl}/api/v1/rate-limit/profiles`, {
      params: payload.params,
    });
  }

  editRateLimitProfile(payload) {
    return this._http.put(
      `${this.apiUrl}/api/v1/rate-limit/profile/${payload.rateLimitProfileId}`,
      payload.body
    );
  }

  deleteRateLimitProfile(payload) {
    return this._http.delete(
      `${this.apiUrl}/api/v1/rate-limit/profile/${payload.rateLimitProfileId}`
    );
  }

  getRateLimitLogs(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/event-logs/by-type?eventType=RATE_LIMIT`,
      {
        params: payload,
      }
    );
  }

  getUsersWithRateLimitProfile(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/rate-limit/user-with-profiles`,
      {
        params: payload,
      }
    );
  }

  getGlobalRateLimitSettings(payload) {
    return this._http.get(`${this.apiUrl}/api/v1/rate-limit/countries`, {
      params: payload,
    });
  }

  addGlobalRateLimitSetting(payload) {
    return this._http.post(
      `${this.apiUrl}/api/v1/rate-limit/country`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  editGlobalRateLimitSetting(payload, rateLimitCountryId: string) {
    return this._http.put(
      `${this.apiUrl}/api/v1/rate-limit/country/${rateLimitCountryId}`,
      payload
    );
  }

  deleteGlobalRateLimitSetting(rateLimitCountryId: string) {
    return this._http.delete(
      `${this.apiUrl}/api/v1/rate-limit/country/${rateLimitCountryId}`
    );
  }

  addRateLimitProfile(body) {
    return this._http.post(`${this.apiUrl}/api/v1/rate-limit/profile`, body);
  }

  getCountries() {
    let filter = new AppFilter({ sidx: 'countryName', rows: 300 });
    return this._http.get(`${this.apiUrl}/public/countries`, {
      params: filter as any,
    });
  }

  getProfiles(appUserId: string) {
    return this._http.get(
      `${this.apiUrl}/api/v1/meta-users/${appUserId}/combined-profiles/`
    );
  }
}
